import {
  FulfillmentOrderAddressSchema,
  type IFulfillmentOrderAddress,
} from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { null as zNull } from "zod";
export const updateReturnAddress = {
  name: "updateReturnAddress" as const,
  input: z.object({
    id: zExt.objectId(),
    address: FulfillmentOrderAddressSchema as IFulfillmentOrderAddress,
  }),
  output: zNull(),
};
